import { render, staticRenderFns } from "./MirListComponent.vue?vue&type=template&id=3d8e1488&scoped=true"
import script from "./MirListComponent.vue?vue&type=script&lang=js"
export * from "./MirListComponent.vue?vue&type=script&lang=js"
import style0 from "./MirListComponent.vue?vue&type=style&index=0&id=3d8e1488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e1488",
  null
  
)

export default component.exports